import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import { getGroupedTagsWithCountFromFeatures } from "@mapsight/core/lib/feature-sources/selectors";
import { tagSwitcherFeatureSourceIdSelector, tagSwitcherFeatureSourcesControllerNameSelector, tagSwitcherSortTags, tagSwitcherToggleableGroups, } from "../../store/selectors";
import { getDocumentLanguage } from "../../helpers/i18n";
import GroupedSwitcher from "../switcher/GroupedSwitcher";
import { TagSwitcherHeader } from "./TagSwitcherHeader";
import { TagSwitcherEntry } from "./TagSwitcherEntry";
const featuresSelector = createSelector([
    tagSwitcherFeatureSourcesControllerNameSelector,
    tagSwitcherFeatureSourceIdSelector,
    (state) => state,
], (controllerName, featureSourceId, state) => {
    var _a, _b, _c;
    return ((_c = (_b = (_a = state[controllerName]) === null || _a === void 0 ? void 0 : _a[featureSourceId]) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.features) || [];
});
function TagSwitcher() {
    const sortTags = useSelector(tagSwitcherSortTags);
    const toggleableGroups = useSelector(tagSwitcherToggleableGroups);
    const featureSourceId = useSelector(tagSwitcherFeatureSourceIdSelector);
    const features = useSelector(featuresSelector);
    const groupedTagData = useMemo(() => getGroupedTagsWithCountFromFeatures(features), [features]);
    const locale = getDocumentLanguage();
    const groupedIds = useMemo(() => Object.entries(groupedTagData).reduce((ids, [group, data]) => {
        const tags = Object.keys(data.tags);
        if (sortTags) {
            tags.sort((a, b) => a.localeCompare(b, locale, { numeric: true }));
        }
        return Object.assign(Object.assign({}, ids), { [group]: tags });
    }, {}), [groupedTagData, sortTags, locale]);
    const renderEntry = useCallback((id, group) => (_jsx(TagSwitcherEntry, { featureSourceId: featureSourceId, tagName: id, tagGroup: group }, `${group}-${id}`)), [featureSourceId]);
    const renderHeader = useCallback((group, props) => (_jsx(TagSwitcherHeader, Object.assign({ featureSourceId: featureSourceId, tagGroup: group, toggleable: toggleableGroups }, props), `${group}-header`)), [featureSourceId, toggleableGroups]);
    return (_jsx(GroupedSwitcher, { className: "ms3-tag-switcher", groupedIds: groupedIds, renderEntry: renderEntry, renderHeader: renderHeader }));
}
export default TagSwitcher;
